import { Center, Grid, GridItem, Stack } from "@chakra-ui/react";
import { Options, Stat } from "components";
import { useState } from "react";
import DistributorsMonthlyGrowthChart from "./distributorsMonthlyGrowthChart";
import { useReport } from "hooks";
import { Moment, Enums } from "config";
import DistributorsMap from "./distributorsMap";

export default function Distributors(){

    const [ period, setPeriod ] = useState(Enums.Period.ALL_PERIOD)
    const distributors_total = useReport('distributors_total', period)
    const distributors_monthly_growth_average = useReport('distributors_monthly_growth_average', period)
    const distributors_demographic_cities = useReport('distributors_demographic_cities', period)
    const distributors_demographic_states = useReport('distributors_demographic_states', period)
    const distributors_demographic_countries = useReport('distributors_demographic_countries', period)

    const periods = Object.keys(Enums.Period).map(item => ({ children: Enums.Period.data(Enums.Period[item]).label, value: Enums.Period[item] }))

    return(
    <>
    <Center mb={12}>
        <Options 
            onChange={setPeriod}
            defaultSelected={period}
            options={periods}
            size="xs"
        />
    </Center>

    <DistributorsMonthlyGrowthChart period={period} />

    <Grid templateColumns="24% 24% 24% 24%" gap={6}>

        <GridItem>
            <Stat.Item
                loading={distributors_total.isLoading}
                label="Núcleos cadastrados"
                value={distributors_total.data?.data}
                helper={`${Moment(distributors_total.data?.metadata?.starts).format('DD/MM/YYYY')} até ${Moment(distributors_total.data?.metadata?.ends).format('DD/MM/YYYY')}`} 
            />
        </GridItem>

        <GridItem>
            <Stat.Item
                loading={distributors_monthly_growth_average.isLoading}
                label="Média de crescimento mensal"
                value={parseInt(distributors_monthly_growth_average.data?.data) + '/mês'}
                helper={`${Moment(distributors_monthly_growth_average.data?.metadata?.starts).format('DD/MM/YYYY')} até ${Moment(distributors_monthly_growth_average.data?.metadata?.ends).format('DD/MM/YYYY')}`} 
            />
        </GridItem>

    </Grid>

    <Grid templateColumns="33% 33% 33%" gap={6} mt={6}>

        <GridItem>
            <Stat.Box title="Núcleos por cidade:" loading={distributors_demographic_cities.isLoading} helper={`${Moment(distributors_demographic_cities.data?.metadata?.starts).format('DD/MM/YYYY')} até ${Moment(distributors_demographic_cities.data?.metadata?.ends).format('DD/MM/YYYY')}`} >
                <Stack spacing={2}>
                    { distributors_demographic_cities?.data?.data?.map((item, index) => <Stat.ListItem label={`${index+1}. ${item.city_name}, ${item.state_name}`} value={item.total} />) }
                </Stack>
            </Stat.Box>
        </GridItem>

        <GridItem>
            <Stat.Box title="Núcleos por estado:" loading={distributors_demographic_states.isLoading} helper={`${Moment(distributors_demographic_states.data?.metadata?.starts).format('DD/MM/YYYY')} até ${Moment(distributors_demographic_states.data?.metadata?.ends).format('DD/MM/YYYY')}`}>
                <Stack spacing={2}>
                    { distributors_demographic_states?.data?.data?.map((item, index) => <Stat.ListItem label={`${index+1}. ${item.state_name}, ${item.country_name}`} value={item.total} />) }
                </Stack>
            </Stat.Box>
        </GridItem>

        <GridItem>
            <Stat.Box title="Núcleos por país:" loading={distributors_demographic_countries.isLoading} helper={`${Moment(distributors_demographic_countries.data?.metadata?.starts).format('DD/MM/YYYY')} até ${Moment(distributors_demographic_countries.data?.metadata?.ends).format('DD/MM/YYYY')}`}>
                <Stack spacing={2}>
                    { distributors_demographic_countries?.data?.data?.map((item, index) => <Stat.ListItem label={`${index+1}. ${String.fromCharCode(item.country_emoji)} ${item.country_name}`} value={item.total} />) }
                </Stack>
            </Stat.Box>
        </GridItem>

    </Grid>

    <DistributorsMap mt={6} />

    <Grid templateColumns="68% 30%" gap={6} mt={6}>

        {/* Map */}
        <GridItem>
            
        </GridItem>

    </Grid>
    
    </>
    )
}